<div id="form-modal" style="max-width: 1300px; width: 95%; margin: 20px auto;"> <!-- Modal Header -->
    <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel" style="padding-top: 1%; font-size: 25px;">
            <span *ngIf="!isLeaveEntry">Edit My Timesheet</span>
            <span *ngIf="isLeaveEntry">Edit My Timesheet</span>
        </h2>
        <h2>
            TODAY'S TOTAL WORKING HOURS
            <span [ngClass]="{'text-danger': this.sumWorkingHours < 8, 'text-success': this.sumWorkingHours >= 8}">
                {{ this.sumWorkingHours }}
            </span>
        </h2>
    </div>

    <div>
        <form #editTimesheet="ngForm" (ngSubmit)="updateTimesheet()">
            <div class="row" style="margin-bottom: 20px;">
                <!-- <div class="row mt-3">
                                    <div class="col-xl-6 col-lg-6">
                                        <label>Start Time:</label>
                                        <input name="tmpStartTime" id="tmpStartTime" class="form-control"
                                            [ngxTimepicker]="timeFrom" [format]="24" [value]="tmpTimeFrom" />
                                        <ngx-material-timepicker (timeSet)="setStartTime($event)" #timeFrom></ngx-material-timepicker>
                                    </div>

                                    <div class="col-xl-6 col-lg-6">
                                        <label>End Time:</label>
                                        <input name="tmpEndTime" id="tmpEndTime" class="form-control"
                                            [ngxTimepicker]="timeTo" [format]="24" [value]="tmpTimeTo"/>
                                        <ngx-material-timepicker (timeSet)="setEndTime($event)" #timeTo></ngx-material-timepicker>
                                    </div>
                                 </div> -->
                <div class="col-md-6">
                    <label
                        style="font-weight: 600; color: #495057; margin-bottom: 5px; display: block; white-space: normal; word-wrap: break-word;">Project</label>
                    <div *ngIf="isLeaveEntry" class="form-control"
                        style="border-radius: 6px; border: 1px solid #ced4da; padding: 8px 12px; font-size: 0.95rem; height: 38px; background-color: #e9ecef; color: #6c757d;">
                        {{getSelectedProjectName()}}
                    </div>
                    <select *ngIf="!isLeaveEntry" class="form-control" [(ngModel)]="timesheet.projectId"
                        (ngModelChange)="ChangeValueCost(timesheet.projectId)" name="selectbasic"
                        style="border-radius: 6px; border: 1px solid #ced4da; padding: 8px 12px; font-size: 0.95rem; height: 38px; background-color: white; color: #495057;">
                        <option value="" disabled selected>-- Select Project --</option>
                        <option *ngFor="let project of projects" [ngValue]="project.id">
                            {{project.projectName}}
                        </option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label
                        style="font-weight: 600; color: #495057; margin-bottom: 5px; display: block; white-space: normal; word-wrap: break-word;">Date</label>
                    <input [ngModel]="timesheet.transDate | ddMmYYYYDate" (ngModelChange)="timesheet.transDate=$event"
                        type="text" class="form-control" placeholder="dd/mm/yyyy" name="tmpDate" disabled
                        style="border-radius: 6px; border: 1px solid #ced4da; padding: 8px 12px; font-size: 0.95rem; height: 38px; background-color: #e9ecef; color: #6c757d;">
                </div>
                <div class="col-md-2">
                    <label
                        style="font-weight: 600; color: #495057; margin-bottom: 5px; display: block; white-space: normal; word-wrap: break-word;">Start
                        Time</label>
                    <input name="tmpTimeFrom" [value]="tmpTimeFrom" [readOnly]="true" [(ngModel)]="searchStartTime"
                        [disabled]="isLeaveEntry"
                        [style.background-color]="isLeaveEntry ? '#e9ecef !important' : 'white !important'"
                        [style.color]="isLeaveEntry ? '#6c757d' : '#495057'"
                        [style.cursor]="isLeaveEntry ? 'not-allowed' : 'pointer'"
                        [style.border]="isTimeOverlap ? '1.5px solid #dc3545' : '1px solid #ced4da'"
                        style="text-align: center; border-radius: 6px; padding: 8px 12px; font-size: 0.95rem; height: 38px;"
                        placeholder="09:00" class="form-control" (click)="!isLeaveEntry && popupTime(startTime)" />

                    <ng-template #startTime let-modalUp>
                        <div id="form-modal">
                            <div class="modal-header">
                                <h2 style="padding-top: 1%; padding-left: 33%;font-size:32px;">Start Time</h2>
                            </div>
                            <div class="row">
                                <div style="padding-left: 23%;padding-right: 3%;">
                                    <select required (change)="changValueStart($event)" name="starttime"
                                        class="form-control rounded"
                                        style="font-size:20px;margin-left:4px;margin-right:7px">
                                        <option value="" disabled selected>Hours</option>
                                        <option style="text-align: center;" *ngFor="let starttime of listStartTime"
                                            [ngValue]="starttime">
                                            {{ starttime }}
                                        </option>
                                    </select>
                                </div>
                                <h2 style="padding-right: 20px;padding-left: 10px;font-size:28px;">:</h2>

                                <div style="padding-left: 5px">
                                    <select required (change)="changValueEnd($event)" name="minutetime"
                                        class="form-control rounded" style="font-size:20px;">
                                        <option value="" disabled selected>Minutes</option>
                                        <option style="text-align:center;" *ngFor="let minutetime of listEndTime"
                                            [ngValue]="minutetime">
                                            {{ minutetime }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div style="padding-left:26%; padding-bottom: 25px; padding-top: 30px;">
                                <button style="padding-left: 33px;padding-right:33px;"
                                    class="btn btn-success btn-adduser" (click)="saveAll(modalUp)"
                                    type="submit">Add</button>
                                <button style="margin-left: 25px;" class="btn btn-danger btn-adduser"
                                    (click)="funcCloseMOdel(modalUp)">Cancel</button>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div class="col-md-2">
                    <label
                        style="font-weight: 600; color: #495057; margin-bottom: 5px; display: block; white-space: normal; word-wrap: break-word;">End
                        Time</label>
                    <input name="tmpTimeTo" [value]="tmpTimeTo" [readOnly]="true" [(ngModel)]="searchEndTime"
                        [disabled]="isLeaveEntry"
                        [style.background-color]="isLeaveEntry ? '#e9ecef !important' : 'white !important'"
                        [style.color]="isLeaveEntry ? '#6c757d' : '#495057'"
                        [style.cursor]="isLeaveEntry ? 'not-allowed' : 'pointer'"
                        style="text-align: center; border-radius: 6px; border: 2px solid #ced4da; padding: 8px 12px; font-size: 0.95rem; height: 38px;"
                        [style.border]="isTimeOverlap ? '1.5px solid #dc3545' : '1px solid #ced4da'" placeholder="18:00"
                        class="form-control" (click)="!isLeaveEntry && popupTime(endTime)" />

                    <ng-template #endTime let-modalUp>
                        <div id="form-modal">
                            <div class="modal-header">
                                <h2 style="padding-top: 1%; padding-left: 33%;font-size:32px;">End Time</h2>
                            </div>
                            <div class="row">
                                <div style="padding-left: 23%;padding-right: 3%;">
                                    <select required (change)="changValueStartEnd($event)" name="starttime"
                                        class="form-control rounded"
                                        style="font-size:20px;margin-left:4px;margin-right:7px">
                                        <option value="" disabled selected>Hours</option>
                                        <option style="text-align: center;" *ngFor="let starttime of listStartTime"
                                            [ngValue]="starttime">
                                            {{ starttime }}
                                        </option>
                                    </select>
                                </div>

                                <h2 style="padding-right: 20px;padding-left: 10px;font-size:28px;">:</h2>

                                <div style="padding-left: 5px">
                                    <select required (change)="changValueEndTime($event)" name="starttime"
                                        class="form-control rounded" style="font-size:20px;">
                                        <option value="" disabled selected>Minutes</option>
                                        <option style="text-align:center;" *ngFor="let minutetime of listEndTime"
                                            [ngValue]="minutetime">
                                            {{ minutetime }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div style="padding-left:26%; padding-bottom: 25px; padding-top: 30px;">
                                <button style="padding-left: 33px;padding-right:33px;"
                                    class="btn btn-success btn-adduser" (click)="saveAllEndTime(modalUp)"
                                    type="submit">Add</button>
                                <button style="margin-left: 25px;" class="btn btn-danger btn-adduser"
                                    (click)="funcCloseMOdelEnd(modalUp)">Cancel</button>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="tw-flex tw-w-full tw-justify-end" *ngIf="isTimeOverlap">
                <p class="tw-text-red-500">*ข้อมูลเวลาซ้ำ {{tmpTimeFrom}} - {{tmpTimeTo}}*</p>
            </div>


            <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-3">
                    <label
                        style="font-weight: 600; color: #495057; margin-bottom: 5px; display: block; white-space: normal; word-wrap: break-word;">Working
                        Hours</label>
                    <input [(ngModel)]="timesheet.workingHours" type="text" class="form-control"
                        style="text-align: center; border-radius: 6px; border: 1px solid #ced4da; padding: 8px 12px; font-size: 0.95rem; background-color: #f8f9fa; color: #6c757d;"
                        placeholder="--:--" name="workingHours" disabled>
                </div>
                <div class="col-md-3 d-flex align-items-end">
                    <div style="display: flex; align-items: center; margin-bottom: 15px;">
                        <input type="checkbox" id="break" name="break" [(ngModel)]="this.timesheet.isBreak"
                            (change)="calWorkingHrs()" [disabled]="isLeaveEntry"
                            style="width: 18px; height: 18px; margin-right: 8px; accent-color: #667eea;">
                        <label for="break"
                            style="margin: 0; font-weight: 500; color: #495057; white-space: normal; word-wrap: break-word;">Lunch
                            Break</label>
                    </div>
                </div>
                <div class="col-md-3 d-flex align-items-end">
                    <div style="display: flex; align-items: center; margin-bottom: 15px;">
                        <input type="checkbox" id="check_onsite_" name="check_onsite_"
                            [(ngModel)]="timesheet.checkOnsite" [disabled]="isLeaveEntry || !getSelectedIsSiteActive()"
                            style="width: 18px; height: 18px; margin-right: 8px; accent-color: #667eea;">
                        <label for="check_onsite_"
                            style="margin: 0; font-weight: 500; color: #495057; white-space: normal; word-wrap: break-word;">Onsite</label>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="timesheet.checkOnsite" style="margin-bottom: 20px; margin-top: 20px;">
                    <div class="row">
                        <div class="col-md-6">
                            <label
                                style="font-weight: 600; color: #495057; margin-bottom: 5px; display: block; white-space: normal; word-wrap: break-word;">
                                <strong>Site Name</strong>
                            </label>

                            <!-- ✅ เปลี่ยนจาก selectedProjectSites เป็น combinedSites -->
                            <select class="form-control" [(ngModel)]="timesheet.siteId" name="siteSelection"
                                (change)="onSiteChange(timesheet.siteId)" [disabled]="isLeaveEntry"
                                [style.background-color]="isLeaveEntry ? '#e9ecef' : 'white'"
                                [style.color]="isLeaveEntry ? '#6c757d' : '#495057'"
                                style="border-radius: 6px; border: 1px solid #ced4da; padding: 8px 12px; font-size: 0.95rem; height: 38px;">

                                <option [value]="null" disabled>Select Site</option>

                                <!-- ✅ ใช้ combinedSites แทน selectedProjectSites -->
                                <option *ngFor="let site of combinedSites; let i = index" [ngValue]="i">
                                    {{ site.siteName }}
                                    <ng-container *ngIf="site.siteCost">
                                        -- {{ site.siteCost | currency:'THB ':'symbol':'1.0-0' }}
                                    </ng-container>
                                </option>
                            </select>
                        </div>
                    </div>
                </div>




                <!-- <div>
                                    <input type="checkbox" id="check_onsite_" name="check_onsite_" [(ngModel)]="this.isOnsite"
                                    (change)=" calWorkingHrs()"/>
                                    <label for="check_onsite_ " >&nbsp; On Site</label>
                                     </div>
                                     <td *ngIf="this.isOnsite">
                                        <input type="text" class="form-control" id="checkboxToEnableOrDisable_{{ item }}" placeholder="Cost" aria-label="Cost"
                                         style="width: 50px;" name="Cost_{{ item }}" [disabled]="costDisplay" />
                                      </td>
                                </div> -->
            </div>

            <div class="row mt-3">
                <div class="col-xl-12">
                    <label
                        style="font-weight: 600; color: #495057; margin-bottom: 5px; display: block; white-space: normal; word-wrap: break-word;">Description:</label>
                    <textarea [(ngModel)]="timesheet.description" class="form-control" rows="3"
                        [disabled]="isLeaveEntry" [style.background-color]="isLeaveEntry ? '#e9ecef' : 'white'"
                        [style.color]="isLeaveEntry ? '#6c757d' : '#495057'"
                        style="border-radius: 6px; border: 1px solid #ced4da; padding: 8px 12px; font-size: 0.95rem; resize: vertical; min-height: 80px;"
                        placeholder="Description" name="description" (input)="autoResizeTextarea($event)"></textarea>
                </div>
            </div>

            <!-- Action Buttons -->
            <div style="display: flex; justify-content: flex-end; align-items: center; gap: 15px; margin-top: 30px;">
                <button type="button" class="btn" (click)="updateTimesheet()"
                    [disabled]=" isTimeOverlap ||isLeaveEntry || (timesheet.checkOnsite && (timesheet.siteId === null || timesheet.siteId === undefined))"
                    [ngStyle]="{
                'padding': '10px 40px',
                'font-weight': '600',
                'border-radius': '12px',
                'border': 'none',
                'font-size': '0.95rem',
                'background-color': isLeaveEntry || isTimeOverlap ? '#78AFFF' : '#007bff',
                'color': 'white',
                'opacity': (isLeaveEntry || (timesheet.checkOnsite && (timesheet.siteId === null || timesheet.siteId === undefined))) ? 0.5 : 1,
                'cursor': (isLeaveEntry || (timesheet.checkOnsite && (timesheet.siteId === null || timesheet.siteId === undefined))) ? 'not-allowed' : 'pointer'
            }">
                    <span *ngIf="!isLeaveEntry">Save</span>
                    <span *ngIf="isLeaveEntry">Save</span>
                </button>

                <button type="button" class="btn" (click)="propModal.close('Back click')" style="padding: 10px 40px; font-weight: 600; border-radius: 12px; border: none;
       font-size: 0.95rem; background-color: #E5E5EA; color: #1c1c1e;">
                    Back
                </button>

                <img src="assets/img/icons/delete.png" role="button" (click)="deleteTimesheet(timesheet.id!)"
                    [hidden]=" isTimeOverlap ||isLeaveEntry || (timesheet.checkOnsite && (timesheet.siteId === null || timesheet.siteId === undefined))"
                    width="40px" height="40px" style="cursor: pointer; transition: transform 0.2s ease;"
                    onmouseover="this.style.transform='scale(1.1)'" onmouseout="this.style.transform='scale(1)'"
                    title="Delete timesheet" />
            </div>

        </form>
    </div>
</div>